const storefrontToken = location.host == 'heyrowan.com' ? '1a7cc20f703dabafd2ceb315d167c6cd' : '7bece4e18db1f02ec54ba3fad0777b25'
const apiUrl = location.host == 'heyrowan.com' ? 'https://pair-piercing.myshopify.com/api/2025-04/graphql' : 'https://rowan-beta.myshopify.com/api/2025-04/graphql'
const apiHeaders = new Headers({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Shopify-Storefront-Access-Token': storefrontToken
})

export const getProductsInfo = (callback, productIds='') => {
  const query = () => `{
    nodes(ids: [${productIds}]) {
      ...on Product {
        id
        handle
        title
        tags
        availableForSale
        vendor
        featuredImage {
          url
          altText
        }
        images(first: 20) {
          edges {
            node {
              altText
              url
            }
          }
        }
        options(first: 3) {
          name
          values
        }
        materials_details: metafield(namespace: "spec", key: "materials_details") {
          value
        }
        pairingOption: metafield(namespace: "filter", key: "quantity") {
          value
        }
        priceRange {
          maxVariantPrice {
            amount
          }
          minVariantPrice {
            amount
          }
        }
        collections(first: 15) {
          edges {
            node {
              title
              tile_message: metafield(namespace: "global", key: "tile_message") {
                value
              }    
            }
          }
        }
        variants(first: 20) {
          edges {
            node {
              id
              availableForSale
              image {
                altText
                url
              }
              price {
                amount
              }
              compareAtPrice {
                amount
              }
              selectedOptions {
                name
                value
              }
              variantHide: metafield(namespace: "filter", key: "hide") {
                value
              }
              look: metafield(namespace: "custom", key: "complete_the_look") {
                value
              }
              force: metafield(namespace: "filter", key: "force") {
                value
              }
            }
          }
        }
      }
    }
  }`
  fetch(apiUrl, {
    method: 'POST',
    headers: apiHeaders,
    body: JSON.stringify({query: query(), variables: {}})
  })
  .then((response) => response.json())
  .then((data) => {
    callback(data.data.nodes)
  })
}